import isEmpty from "lodash/isEmpty";

const setMarginTop = (el1 , el2 , marginTop = 0) => {    
    if (!isEmpty(el1) && !isEmpty(el2)) {
      const bottom = el1.getBoundingClientRect().bottom;
      el2.style.marginTop = `${bottom + marginTop}px`;
    }
}

export default setMarginTop;